__turbopack_context__.v({
  "bodyContainer": "YourSubscription-module__PaVV1a__bodyContainer",
  "container": "YourSubscription-module__PaVV1a__container",
  "containerExpanded": "YourSubscription-module__PaVV1a__containerExpanded",
  "entryStackItem": "YourSubscription-module__PaVV1a__entryStackItem",
  "entryStackList": "YourSubscription-module__PaVV1a__entryStackList",
  "headerContainer": "YourSubscription-module__PaVV1a__headerContainer",
  "paidToday": "YourSubscription-module__PaVV1a__paidToday",
  "planSection": "YourSubscription-module__PaVV1a__planSection",
  "separator": "YourSubscription-module__PaVV1a__separator",
  "shoppingCartImageContainer": "YourSubscription-module__PaVV1a__shoppingCartImageContainer",
  "shoppingCartImageWrapper": "YourSubscription-module__PaVV1a__shoppingCartImageWrapper",
  "subscriptionSection": "YourSubscription-module__PaVV1a__subscriptionSection",
  "subscriptionSectionImageContainer": "YourSubscription-module__PaVV1a__subscriptionSectionImageContainer",
  "wrapper": "YourSubscription-module__PaVV1a__wrapper",
});
